import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import { Button, Dropdown, Menu, Select, Spin, Tooltip } from 'antd'
import { Funnel, List, SquaresFour } from 'phosphor-react'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { ReportCommentReason, ReportVideoReason } from 'utility'
// import { FlexRowBetween } from './Common'
import { StyledCheckboxGroup, StyledCloseIcon } from './StyleCloseIcon'

const StyledButton = styled(Button)`
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  font-size: 12px;
  border-radius: 4px;
  height: 36px;
  font-weight: 500;
  padding: 8px 16px;

  &:hover {
    background: ${({ theme }) => theme.colors.primary} !important;
    color: ${({ theme }) => theme.colors.white} !important;
  }
`
const StyledEditButton = styled(Button)`
  background: #e5ebff;
  color: #2454ff;
  border: none;
  font-size: 16px;
  border-radius: 8px;
  font-weight: bold;
  padding: 16px;
`
const FiltersTitle = styled.h6`
  font-size: 14px;
  margin-bottom: 0;
  width: 100%;
  padding-bottom: 5px;
  color: rgb(108, 108, 108);
`

export const PrimaryButton = ({
  type,
  className,
  children,
  onClick,
  fullWidth,
  loading,
  icon,
  ...props
}) => {
  return (
    <StyledButton
      variant={type}
      className={className}
      style={{ width: fullWidth ? '100%' : '' }}
      onClick={onClick}
      {...props}
    >
      {Boolean(loading) && <Spin />}
      {icon && icon} {children}
    </StyledButton>
  )
}

export const PrimaryEditButton = ({
  type,
  className,
  children,
  onClick,
  fullWidth,
  loading,
  icon,
  ...props
}) => {
  return (
    <StyledEditButton
      variant={type}
      className={className}
      style={{ width: fullWidth ? '100%' : '' }}
      onClick={onClick}
      {...props}
    >
      {Boolean(loading) && <Spin />}
      {icon && icon} {children}
    </StyledEditButton>
  )
}

export const SecondaryButton = ({
  type,
  className,
  children,
  onClick,
  fullWidth,
  loading,
  ...props
}) => {
  return (
    <Button
      variant={type}
      className={className}
      style={{ width: fullWidth ? '100%' : '' }}
      onClick={onClick}
      {...props}
    >
      {loading ? <Spin /> : ''} {children}
    </Button>
  )
}

const CustomButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #85c78f;
  background-color: #e8f6e8;
  color: #2e8540;
  font-size: 16px;
  padding: 8px 20px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  height: 50px;
  border-radius: 20px;
  margin-right: 10px;
  &:hover {
    background-color: #e8f6e8 !important;
    border-color: #78ba85 !important;
    color: #267033 !important;
  }
`

export const CustomUploadButton = ({ title }) => (
  <div className="d-flex justify-content-center">
    <CustomButton>
      <UploadOutlined />
      <p className="mb-0">{title}</p>
    </CustomButton>
  </div>
)

const DeleteButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: none;
  color: #555;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: red;
  }
`

export const CustomDeleteButton = ({ onClick }) => (
  <DeleteButton onClick={onClick}>
    <DeleteOutlined />
  </DeleteButton>
)

const EditButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: none;
  color: #555;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: blue;
  }
`

export const CustomEditButton = ({ onClick }) => (
  <EditButton className="mr-2" onClick={onClick}>
    <EditOutlined />
  </EditButton>
)

const CommonStyledButton = styled.button`
  background: ${({ variant }) => {
    switch (variant) {
      case 'red':
        return '#fde8e6'
      case 'blue':
        return '#e8edff'
      case 'green':
      default:
        return '#E0F9E6'
    }
  }};
  color: ${({ variant }) => {
    switch (variant) {
      case 'red':
        return '#e74c3c'
      case 'blue':
        return '#2a63f7'
      case 'green':
      default:
        return '#24D24D'
    }
  }};
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 12px;
  padding: 4px 6px;
  border: none;
  border-radius: 8px;
  backgound: none;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
  margin-right: 10px;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6; /* Optional: Reduce opacity to indicate disabled state */
  }
  &:hover {
    background: ${({ variant }) => {
      switch (variant) {
        case 'red':
          return '#fcd3cf'
        case 'blue':
          return '#d2e0ff'
        case 'green':
        default:
          return '#b2ebf2'
      }
    }};
  }
`

export const CommonColorButton = ({
  variant = 'red',
  onClick,
  title,
  disabled,
  icon,
  tooltipTitle,
}) => {
  const onlyIcon = icon && !title
  const buttonContent =
    title && icon ? (
      <>
        {title} {icon}
      </>
    ) : (
      title || icon
    )

  const button = (
    <CommonStyledButton disabled={disabled} variant={variant} onClick={onClick}>
      {buttonContent}
    </CommonStyledButton>
  )

  return onlyIcon ? (
    <Tooltip title={tooltipTitle || 'Action'}>{button}</Tooltip>
  ) : (
    button
  )
}
const SortContainer = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: #f3f4f6;
  }
`

const SortText = styled.span`
  color: #6b7280;
  padding: 1px;
  margin-right: 4px;
`

const SortValue = styled.span`
  font-weight: bold;
  color: #000;
`

export const SortButton = ({
  label = 'Sort by:',
  value = 'newest',
  onSelect,
  options = [
    { label: 'Newest', value: 'newest' },
    { label: 'Oldest', value: 'oldest' },
    { label: 'Popular', value: 'popular' },
  ],
}) => {
  const menu = (
    <Menu onClick={e => onSelect(e.key)}>
      {options.map(option => (
        <Menu.Item key={option.value}>{option.label}</Menu.Item>
      ))}
    </Menu>
  )

  return (
    <SortContainer>
      <SortText>{label}</SortText>
      <Dropdown overlay={menu} trigger={['click']}>
        <SortValue>
          {options.find(opt => opt.value === value)?.label || value}{' '}
          <DownOutlined />
        </SortValue>
      </Dropdown>
    </SortContainer>
  )
}
const FilterWrapper = styled.div`
  position: relative;
`

const FilterContainer = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  padding: 10px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 300px;
  z-index: 10;
  max-height: 400px;
  overflow-y: auto;

  /* Custom Thin Scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b0b0;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

export const FilterButton = ({
  label = 'Filters',
  handleFilter,
  component,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [dateRange, setDateRange] = useState('')
  const [selectedReasons, setSelectedReasons] = useState([])
  const modalRef = useRef(null)
  const buttonRef = useRef(null)

  const toggleFilters = event => {
    if (buttonRef.current && buttonRef.current.contains(event.target)) {
      setIsOpen(prev => !prev)
    }
  }

  const applyFilters = () => {
    const data = {
      flagReasons: Array.isArray(selectedReasons) ? selectedReasons : [],
      dateRange,
    }
    handleFilter(data)
    setIsOpen(false)
  }

  const onChange = checkedValues => {
    setSelectedReasons(checkedValues)
  }

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }
    if (isOpen) {
      document.addEventListener('click', handleClickOutside)
    }
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [isOpen])

  return (
    <FilterWrapper>
      <SortContainer ref={buttonRef} onClick={toggleFilters}>
        <SortText>
          <Funnel size={18} color="#000" />
        </SortText>
        <SortValue>{label}</SortValue>
      </SortContainer>

      {isOpen && (
        <FilterContainer ref={modalRef}>
          <div
            className="d-flex justify-content-between align-items-center  border-bottom"
            style={{ borderColor: '#ddd' }}
          >
            <FiltersTitle>Filters</FiltersTitle>
            <StyledCloseIcon onClick={() => setIsOpen(false)}>
              ✖
            </StyledCloseIcon>
          </div>
          {/* Close Button */}

          {/* Date Range Dropdown */}
          <FilterItem>
            <label className="mb-1 mt-2">Date Range:</label>
            <Select
              style={{ width: '100%' }}
              placeholder="Select Date Range"
              value={dateRange}
              onChange={value => {
                setDateRange(value)
              }}
              getPopupContainer={triggerNode => triggerNode.parentNode}
            >
              <Select.Option value="today">Today</Select.Option>
              <Select.Option value="last7">Last 7 Days</Select.Option>
              <Select.Option value="last30">Last 30 Days</Select.Option>
              <Select.Option value="last60">Last 60 Days</Select.Option>
              <Select.Option value="last6Month">Last 6 Months</Select.Option>
              <Select.Option value="lastYear">Last 1 Year</Select.Option>
            </Select>
          </FilterItem>

          {/* Checkbox Group */}
          <FilterItem>
            <label className="mb-1">Reason for Flagging:</label>
            <StyledCheckboxGroup
              options={
                component === 'video' ? ReportVideoReason : ReportCommentReason
              }
              value={selectedReasons}
              onChange={onChange}
              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            />
          </FilterItem>

          {/* Apply Button */}
          <PrimaryButton type="primary" block onClick={applyFilters}>
            Apply Filters
          </PrimaryButton>
        </FilterContainer>
      )}
    </FilterWrapper>
  )
}

const FilterItem = styled.div`
  margin-bottom: 10px;
  display: flex;
  // max-height: 400px;
  // overflow-y: auto;
  flex-direction: column;
`

export const CancelButton = styled.button`
  background: #ffe9e5;
  color: #e22400;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 14px;
  width: 250px;
  height: 48px;
  gap: 8px;
  padding: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CancleButton = ({ variant = 'remove', onClick, children }) => (
  <CancelButton variant={variant} onClick={onClick}>
    {children}
  </CancelButton>
)

export const MoveWinners = styled.button`
  width: 250px;
  height: 48px;
  gap: 8px;
  padding: 16px;
  border-radius: 8px;
  background: linear-gradient(180deg, #2454ff 0%, #0033eb 100%);
  color: white;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 14px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const MoveWinnersButton = ({
  variant = 'remove',
  onClick,
  children,
  disabled,
}) => (
  <MoveWinners disabled={disabled} variant={variant} onClick={onClick}>
    {children}
  </MoveWinners>
)

const ToggleWrapper = styled.div`
  display: inline-flex;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
  margin-left: 6px;
`

const ToggleOption = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: #5c67ca;

  font-size: 14px;
  background-color: ${props => (props.active ? '#5C67CA' : 'white')};
  color: ${props => (props.active ? 'white' : '#333')};
  border: none;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: ${props => (props.active ? '#2454FF' : '#f0f0f0')};
  }
`

export const ToggleViewButton = ({ onToggle }) => {
  const [view, setView] = useState('grid')

  const handleToggle = newView => {
    setView(newView)
    if (onToggle) onToggle(newView)
  }

  return (
    <ToggleWrapper>
      <ToggleOption
        active={view === 'grid'}
        onClick={() => handleToggle('grid')}
      >
        <SquaresFour size={24} className="my-1" />
      </ToggleOption>
      <ToggleOption
        active={view === 'list'}
        onClick={() => handleToggle('list')}
      >
        <List className="my-1" size={24} />
      </ToggleOption>
    </ToggleWrapper>
  )
}
